export default {"src":"/_next/static/media/mileprogram-gift-flow.98545529.svg","height":87,"width":308,"blurWidth":0,"blurHeight":0};